module.exports = __webpack_public_path__ + "img/h-bga.533bf761.png";